export const UNRATED = {
  label: 'Unrated',
  value: null,
  color: 'light-grey',
};
